<div class="bg-opacity-50 max-w-fit rounded-[4px] bg-white px-sm py-xs">
  <div class="flex shrink-0 flex-row items-center justify-center gap-x-xs text-xs font-bold text-white">
    <ng-content select="[content=recommendedByText]"></ng-content>
    <div class="flex h-full shrink-0 flex-row items-center justify-center gap-x-2xs">
      <div class="-mb-[3px] flex items-center justify-center">
        <ng-content select="[content=logo]"></ng-content>
      </div>
      <div>
        <ng-content select="[content=agencyName]"></ng-content>
      </div>
    </div>
  </div>
</div>
